/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * 
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 * 
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import PropTypes from 'prop-types';

class ConfirmModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: props.isOpen,
            timerActive: false,
            timerCount: props.timerDuration || 60
        };
        this.toggle = this.toggle.bind(this);
        this.intervalId = null;
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    clearTimer = () => {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    startTimer = () => {
        this.setState({ timerActive: true });
        this.intervalId = setInterval(() => {
            const newCount = this.state.timerCount - 1;
            if (newCount < 1) {
                this.clearTimer();
                this.setState({ timerCount: 0, timerActive: false, modal: false }, () => {
                    if (this.props.onTimerComplete) {
                        this.props.onTimerComplete();
                    }
                });
            } else {
                this.setState({ timerCount: newCount });
            }
        }, 1000);
    }

    toggle = (params) => {
        this.clearTimer();

        this.setState(prevState => ({
            modal: !prevState.modal,
            timerActive: false,
            timerCount: this.props.timerDuration || 60
        }));

        if (params === 'ok') {
            this.props.onClose(params);
        } else {
            this.props.onClose('cancel');
        }
    }

    handleYesClick = () => {
        if (this.props.showTimer) {
            this.props.onClose('ok');
            this.startTimer();
        } else {
            this.toggle('ok');
        }
    }

    render() {
        const { okayButtonText, cancelButtonText, message } = this.props;
        const { timerActive, timerCount } = this.state;
        const timeDisplay = timerCount >= 10 ? timerCount : '0' + timerCount;

        return (
            <div>
                <Modal fade centered autoFocus isOpen={this.state.modal} toggle={timerActive ? undefined : this.toggle}>
                    <ModalBody className="text-center p-4">
                        <p>{message}</p>
                        {timerActive && (
                            <div className="mb-3">
                                <p style={{ fontSize: '14px', color: '#666', marginBottom: '5px' }}>
                                    Closing sales in:
                                </p>
                                <p style={{ fontSize: '28px', fontWeight: 'bold', color: '#dc3545', marginBottom: '10px' }}>
                                    {timeDisplay}s
                                </p>
                                <div style={{ width: '100%', height: '4px', backgroundColor: '#e9ecef', borderRadius: '2px' }}>
                                    <div style={{
                                        width: `${(timerCount / (this.props.timerDuration || 60)) * 100}%`,
                                        height: '100%',
                                        backgroundColor: '#dc3545',
                                        borderRadius: '2px',
                                        transition: 'width 1s linear'
                                    }}></div>
                                </div>
                            </div>
                        )}
                        <Button
                            color="danger"
                            className="mr-2"
                            disabled={timerActive}
                            onClick={this.handleYesClick}
                        >
                            {timerActive ? 'Processing...' : okayButtonText}
                        </Button>
                        <Button
                            outline
                            color="primary"
                            disabled={timerActive}
                            onClick={() => this.toggle('cancel')}
                        >
                            {cancelButtonText}
                        </Button>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

ConfirmModal.defaultProps = {
    okayButtonText: 'Yes',
    cancelButtonText: 'No',
    message: 'Are you sure you want to continue?',
    showTimer: false,
    timerDuration: 60
}

ConfirmModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    okayButtonText: PropTypes.string,
    cancelButtonText: PropTypes.string,
    message: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    showTimer: PropTypes.bool,
    timerDuration: PropTypes.number,
    onTimerComplete: PropTypes.func
}

export default ConfirmModal;
